import ScrollMagic from 'scrollmagic';

export default function initSme () {
	initSmeLine();
}

import { isScrolledIntoView } from '../utils';

function initSmeLine() {
	const elements = document.querySelectorAll('.sme-header__line, .top-section__line, .action-top__line');

	Array.prototype.forEach.call(elements, (el) => {
		const body = document.body;
		const section = el.parentNode;
		const targetId = el.getAttribute('data-id-target');
		const target = document.getElementById(targetId);

		// hide fixed button when form (target) into viewport
		if(target) {
			document.addEventListener('scroll', () => {
				el.style.display = isScrolledIntoView(target) ? 'none' : 'block';
			}, { passive: true })
		}

		// hide fixed button when it achive bottom
		document.addEventListener('scroll', () => {
			el.style.display = (window.pageYOffset + window.innerHeight >= body.offsetHeight) ? 'none' : 'block';
		}, { passive: true })

		new ScrollMagic.Scene({
			triggerElement: section,
			duration() {
				return section.offsetHeight;
			},
		})
		.on('end', (e) => {
			if (e.state === 'AFTER') {
				el.classList.add('_scroll');
			} else {
				el.classList.remove('_scroll');
			}
		})
		.addTo(
			new ScrollMagic.Controller({
				globalSceneOptions: { triggerHook: 0 },
			})
		);
	});

	// const headerBurger = document.querySelector('.header-burger');
	// if (headerBurger) {
	// 	headerBurger.addEventListener('click', () => {
	// 		const headerBurgerOpened = document.querySelector( '.header-burger__dialog');
	// 		const smeHeaderLine = document.querySelector( '.sme-header__line');
	// 		if (smeHeaderLine) {
	// 			headerBurgerOpened ? smeHeaderLine.style.opacity = '0' : smeHeaderLine.style.opacity = '1';
	// 		}
	// 	});
	// }

}
